import * as React from "react";
import { useSelector } from "react-redux";
import { getUserAccessRights } from "../../applications/common/reducers/userReducer";
import { isAuthorizedToComponent } from "../../utilities/authUtils";
import { AccessRights } from "api/models/AccessRights";

export interface AuthorizedComponentProps {
  companyId?: string;
  accessRights: AccessRights[];
  requireAll?: boolean;
}

const AuthorizedComponent: React.FunctionComponent<AuthorizedComponentProps> = (props) => {
  const userAccessRights = useSelector(getUserAccessRights);
  if (
    isAuthorizedToComponent(userAccessRights, {
      identifier: props.companyId,
      operation: props.requireAll ? "all" : "any",
      accessRights: props.accessRights
    })
  ) {
    return <>{props.children}</>;
  } else {
    return <></>;
  }
};

export default AuthorizedComponent;
